module.exports = "/_next/static/images/Compliance@2x-0bfabd00d449cda414d107cc66158e2d.png";